// Setup Cart Drawer Form for AJAX add to cart
function setupCartDrawerForm() {
  const form = document.querySelector(".product-single__form");
  if (!form) return;

  form.addEventListener("submit", (e) => {
    e.preventDefault();

    const formData = new FormData(form);
    // Ensure .js endpoint for cart AJAX
    const jsonAction = form.action.endsWith(".js")
      ? form.action
      : form.action + ".js";
    fetch(jsonAction, {
      method: "POST",
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((res) => res.text())
      .then((text) => {
        try {
          // Always use jsonAction for endpoint reference if needed
          const data = JSON.parse(text);
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", { detail: data })
          );
        } catch (err) {
          console.error("[CartDrawer] AJAX add failed - not valid JSON", err);
          console.error("[CartDrawer] Response body:", text);
        }
      })
      .catch((err) => console.error("[CartDrawer] AJAX add failed", err));
  });
}
// Utility function to preload an image
// Debug toggle for swatch logging
const SWATCH_DEBUG = false;

// Polyfill for Shopify.formatMoney if missing
function formatMoney(cents, format = "£{{amount}}") {
  const amount = (cents / 100).toFixed(2);
  return format.replace("{{amount}}", amount);
}
const preloaded = new Set();

const preloadImage = (url) => {
  if (preloaded.has(url)) return;
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "image";
  link.href = url;
  // Add onerror guard: remove link if broken
  link.onerror = () => {
    if (link.parentNode) link.parentNode.removeChild(link);
  };
  document.head.appendChild(link);
  preloaded.add(url);
};

const getOptimisedImageUrl = (url) =>
  url.replace(/(\.jpg|\.png)(\?.*)?$/, "_50x50.webp");

document.addEventListener("DOMContentLoaded", () => {
  function updateHeaderHeight() {
    const header = document.querySelector("header");
    if (!header) {
      if (SWATCH_DEBUG) {
        console.warn("[updateHeaderHeight] Header not found");
      }
      return;
    }

    const height = header.offsetHeight;
    document.documentElement.style.setProperty(
      "--header-height",
      `${height}px`
    );
    if (SWATCH_DEBUG) {
      console.log(`[updateHeaderHeight] Set --header-height to ${height}px`);
    }
  }

  if (SWATCH_DEBUG) console.log("[Swatch Init] DOMContentLoaded");

  const product = window.productData;

  if (!product) {
    console.error("[Swatch Error] window.productData is undefined or null");
    return;
  }

  if (SWATCH_DEBUG) console.log("[Swatch] Product title:", product.title);
  if (SWATCH_DEBUG) console.log("[Swatch] Product options:", product.options);

  let baseProductName = product.title;

  if (SWATCH_DEBUG) console.log("[Swatch] Checking product option names:");
  product.options.forEach((option, index) => {
    if (SWATCH_DEBUG) console.log(`→ Option ${index}: "${option}"`);
  });

  const colorOptionIndex = product.options.findIndex((option) =>
    ["colour", "color"].includes(option.trim().toLowerCase())
  );

  if (colorOptionIndex !== -1) {
    if (SWATCH_DEBUG)
      console.log("[Swatch] Found color option at index:", colorOptionIndex);

    if (SWATCH_DEBUG)
      console.log(
        "[Swatch] Extracted color values from variants:",
        product.variants.map((v) => v.options)
      );
    const colorValues = product.variants
      .map((v) => v.options[colorOptionIndex])
      .filter(Boolean);
    if (SWATCH_DEBUG) console.log("[Swatch] Color values found:", colorValues);

    const escapedColors = colorValues.map((color) =>
      color.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    );
    const colorRegex = new RegExp(
      `\\s*(-\\s*)?(${escapedColors.join("|")})$`,
      "i"
    );

    baseProductName = product.title.replace(colorRegex, "").trim();
    if (SWATCH_DEBUG)
      console.log(
        "[Swatch] Base product name after stripping color:",
        baseProductName
      );
  } else {
    if (SWATCH_DEBUG) {
      console.warn("[Swatch] No 'Colour' or 'Color' option found");
    }
  }

  const fetchRelatedProducts = async (baseName) => {
    if (SWATCH_DEBUG)
      console.log("[Swatch] Fetching related products for:", baseName);

    const slugified = baseName
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]/g, "");
    const cacheKey = `relatedProducts_${slugified}`;
    const cachedData = sessionStorage.getItem(cacheKey);

    if (cachedData) {
      try {
        const parsedData = JSON.parse(cachedData);
        const now = new Date().getTime();
        const cacheAge = now - parsedData.timestamp;
        const cacheExpiration = 30 * 60 * 1000;

        if (cacheAge < cacheExpiration) {
          if (SWATCH_DEBUG)
            console.log("[Swatch] Using cached related products");
          return parsedData.products;
        } else {
          if (SWATCH_DEBUG) console.log("[Swatch] Cache expired, clearing");
          sessionStorage.removeItem(cacheKey);
        }
      } catch (error) {
        console.error("[Swatch Error] Failed to parse cache:", error);
        sessionStorage.removeItem(cacheKey);
      }
    }

    try {
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(
          baseName
        )}&resources[type]=product&resources[options][unavailable_products]=last`
      );

      const data = await response.json();
      const products = data.resources.results.products.filter((product) =>
        product.title.toLowerCase().startsWith(baseName.toLowerCase())
      );

      if (SWATCH_DEBUG)
        console.log("[Swatch] Related products fetched:", products);

      const leanProducts = products.map((p) => ({
        title: p.title,
        url: p.url,
        available: p.available,
        featured_image: { url: p.featured_image?.url },
      }));

      sessionStorage.setItem(
        cacheKey,
        JSON.stringify({
          timestamp: Date.now(),
          products: leanProducts,
        })
      );

      return products;
    } catch (error) {
      console.error("[Swatch Error] Failed to fetch related products:", error);
      return [];
    }
  };

  const populateRelatedProducts = (products, baseProductName) => {
    if (SWATCH_DEBUG) console.log("[Swatch] Populating related products");

    // --- Preload the full section and main image for each swatch product ---
    const sectionWrapper = document.querySelector(
      ".product-section[data-section-id]"
    );
    const sectionId = sectionWrapper?.dataset.sectionId || "product-template";
    products.forEach((product) => {
      const productUrl = new URL(product.url, window.location.origin);
      productUrl.searchParams.set("section_id", sectionId);
      const cacheKey = `sectionCache_${product.url}`;

      fetch(productUrl.toString())
        .then((res) => res.text())
        .then((html) => {
          sessionStorage.setItem(cacheKey, html);

          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const mainImg = doc.querySelector(".product-main-slide img");
          if (mainImg && mainImg.src) {
            const preload = new Image();
            preload.src = mainImg.src;
          }
        })
        .catch((err) => {
          if (SWATCH_DEBUG) {
            console.warn(
              `[Swatch Preload] Failed to fetch or parse: ${productUrl}`,
              err
            );
          }
        });
    });
    // ----------------------------------------------------------------------

    const swatchMount = document.querySelector(".js-related-color-swatches");
    const swatchLabel = document.querySelector(".swatch-label .selected-color");

    if (!swatchMount) {
      if (SWATCH_DEBUG) {
        console.warn("[Swatch] .js-related-color-swatches container not found");
      }
      return;
    }

    swatchMount.innerHTML = ""; // Clear if anything is already there

    if (products.length === 0) {
      if (SWATCH_DEBUG) {
        console.warn("[Swatch] No related products found to populate");
      }
      return;
    }

    let updateLabelTimeout;

    const currentProductURL = window.location.pathname.replace(/\/$/, "");

    products.forEach((product, index) => {
      if (!product.featured_image || !product.featured_image.url) return;

      // Preload the main image (2880px) of the associated product
      if (product.featured_image?.url) {
        const highRes = product.featured_image.url.replace(
          /(width=)\d+/,
          "width=2880"
        );
        const preloadMain = document.createElement("link");
        preloadMain.rel = "preload";
        preloadMain.as = "image";
        preloadMain.href = highRes;
        preloadMain.fetchPriority = "high";
        document.head.appendChild(preloadMain);
      }

      const listItem = document.createElement("li");
      listItem.classList.add("swatch-item");
      listItem.setAttribute("role", "listitem");

      const link = document.createElement("a");
      link.href = product.url.split("?")[0];
      link.title = product.title;
      link.classList.add("swatch-link", "block-swatch");
      link.setAttribute("role", "button");

      if (!product.available) {
        link.classList.add("disabled");
        link.setAttribute("aria-disabled", "true");
        link.setAttribute("tabindex", "-1");
        link.addEventListener("click", (e) => e.preventDefault());
        link.title = "Out of stock";
      }

      const productURL = new URL(
        product.url,
        window.location.origin
      ).pathname.replace(/\/$/, "");
      if (productURL === currentProductURL) {
        link.classList.add("active");
        link.setAttribute("aria-pressed", "true");
        if (SWATCH_DEBUG)
          console.log(
            "[Swatch] Marking current product as active:",
            productURL
          );
      }

      const colorName = product.title
        .replace(baseProductName, "")
        .trim()
        .replace(/^-/, "")
        .trim();

      if (colorName) {
        const tooltip = document.createElement("span");
        tooltip.className = "swatch-tooltip";
        tooltip.textContent = colorName;
        link.appendChild(tooltip);
      }

      const img = document.createElement("img");
      img.src = product.featured_image.url;
      const smallImg = new Image();
      smallImg.onload = () => {
        img.src = smallImg.src;
      };
      smallImg.src = getOptimisedImageUrl(product.featured_image.url);
      // Retain other attributes
      img.alt = product.title;
      img.classList.add("swatch-image");
      img.decoding = "async";
      img.loading = window.innerWidth < 768 && index > 2 ? "lazy" : "eager";
      img.width = 44;
      img.height = 44;

      link.appendChild(img);
      listItem.appendChild(link);

      link.addEventListener("click", (event) => {
        event.preventDefault();
        clearTimeout(updateLabelTimeout);
        updateLabelTimeout = setTimeout(() => {
          if (swatchLabel) {
            const colorName = product.title
              .replace(baseProductName, "")
              .trim()
              .replace(/^-/, "")
              .trim();
            swatchLabel.textContent = colorName || product.title;
          }

          const sectionWrapper = document.querySelector(
            ".product-section[data-section-id]"
          );
          const sectionId =
            sectionWrapper?.dataset.sectionId || "product-template";
          const cacheKey = `sectionCache_${product.url}`;
          const cachedHTML = sessionStorage.getItem(cacheKey);

          // Use cached HTML if available, else fallback to fetch as before
          if (cachedHTML) {
            const doc = new DOMParser().parseFromString(
              cachedHTML,
              "text/html"
            );
            const newSection = doc.getElementById(
              `shopify-section-${sectionId}`
            );
            const currentSection = document.getElementById(
              `shopify-section-${sectionId}`
            );
            const doReplaceSection = () => {
              if (newSection && currentSection) {
                if (SWATCH_DEBUG) {
                  console.log(
                    "[Swatch] Replacing current section with new section"
                  );
                }
                currentSection.replaceWith(newSection);
                document.dispatchEvent(
                  new CustomEvent("shopify:section:load", {
                    detail: { sectionId: sectionId },
                  })
                );

                // Try to reselect the previously selected size
                const selectedSize = document.querySelector(
                  '.variant-input input[type="radio"]:checked'
                );
                if (selectedSize) {
                  const value = selectedSize.value;
                  const index = selectedSize.dataset.index;
                  const newInput = newSection.querySelector(
                    `.variant-input input[type="radio"][data-index="${index}"][value="${value}"]`
                  );
                  if (newInput) {
                    newInput.checked = true;
                    newInput.dispatchEvent(
                      new Event("change", { bubbles: true })
                    );
                  } else {
                    if (SWATCH_DEBUG) {
                      console.warn(
                        "[Swatch] Could not find matching size in new section"
                      );
                    }
                  }
                }

                setupCartDrawerForm();
                if (theme.CartDrawer) {
                  const drawerForm = document.querySelector("#CartDrawerForm");
                  if (drawerForm) {
                    window.cartDrawer = new theme.CartDrawer();
                    if (SWATCH_DEBUG) {
                      console.log("[CartDrawer] Reinitialized");
                    }
                  } else {
                    if (SWATCH_DEBUG) {
                      console.warn(
                        "[CartDrawer] Form not found, skipping drawer init"
                      );
                    }
                  }
                }

                // Re-initialize VariantAvailability
                const productJsonEl = newSection.querySelector(
                  "[data-product-json]"
                );
                const productData = productJsonEl
                  ? JSON.parse(productJsonEl.innerHTML)
                  : null;
                if (productData) {
                  const container = newSection.querySelector(".product-block");
                  const type = container.querySelector(
                    ".variant-input-wrap select"
                  )
                    ? "dropdown"
                    : "button";
                  new theme.VariantAvailability({
                    type: type,
                    variantsObject: productData.variants,
                    currentVariantObject: productData.currentVariant,
                    container: container,
                    namespace: "",
                  });
                } else {
                  if (SWATCH_DEBUG) {
                    console.warn(
                      "[Swatch] Could not reinitialize VariantAvailability: no product JSON found"
                    );
                  }
                }

                window.history.pushState({}, "", product.url);

                // 🔁 Re-run swatch population
                fetchRelatedProducts(baseProductName).then(
                  (relatedProducts) => {
                    populateRelatedProducts(relatedProducts, baseProductName);
                  }
                );

                // Klarna installment update on variant change
                const klarnaContainer =
                  document.getElementById("klarna-installment");
                const newPriceEl = newSection.querySelector(
                  "[data-product-json]"
                );
                if (klarnaContainer && newPriceEl) {
                  try {
                    const productJson = JSON.parse(newPriceEl.innerHTML);
                    const variantPrice = productJson.currentVariant?.price;
                    if (variantPrice) {
                      const formattedInstallment = Shopify.formatMoney(
                        variantPrice / 3,
                        "{{ amount_with_currency }}"
                      );
                      const amountEl = klarnaContainer.querySelector(
                        ".installment-amount"
                      );
                      if (amountEl) amountEl.textContent = formattedInstallment;
                    }
                  } catch (e) {
                    if (SWATCH_DEBUG) {
                      console.warn(
                        "[Klarna] Failed to update installment price",
                        e
                      );
                    }
                  }
                }
              }
            };
            doReplaceSection();
            return;
          }

          // fallback to old fetch logic if cache not present
          const productUrl = new URL(product.url, window.location.origin);
          productUrl.searchParams.set("section_id", sectionId);
          if (SWATCH_DEBUG) {
            console.log("[Swatch] Fetching section:", productUrl.toString());
          }

          fetch(productUrl.toString())
            .then((res) => {
              if (SWATCH_DEBUG) {
                console.log("[Swatch] Response status:", res.status);
              }
              return res.text();
            })
            .then((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, "text/html");
              const newSection = doc.getElementById(
                `shopify-section-${sectionId}`
              );
              const currentSection = document.getElementById(
                `shopify-section-${sectionId}`
              );

              const mainImg = newSection?.querySelector(
                ".product-main-slide img"
              );

              if (!newSection) {
                if (SWATCH_DEBUG) {
                  console.warn("[Swatch] newSection not found in response HTML");
                }
              }
              if (!currentSection) {
                if (SWATCH_DEBUG) {
                  console.warn("[Swatch] currentSection not found in document");
                }
              }

              const doReplaceSection = () => {
                if (newSection && currentSection) {
                  console.log(
                    "[Swatch] Replacing current section with new section"
                  );
                  currentSection.replaceWith(newSection);
                  document.dispatchEvent(
                    new CustomEvent("shopify:section:load", {
                      detail: { sectionId: sectionId },
                    })
                  );

                  // Try to reselect the previously selected size
                  const selectedSize = document.querySelector(
                    '.variant-input input[type="radio"]:checked'
                  );
                  if (selectedSize) {
                    const value = selectedSize.value;
                    const index = selectedSize.dataset.index;
                    const newInput = newSection.querySelector(
                      `.variant-input input[type="radio"][data-index="${index}"][value="${value}"]`
                    );
                    if (newInput) {
                      newInput.checked = true;
                      newInput.dispatchEvent(
                        new Event("change", { bubbles: true })
                      );
                    } else {
                      if (SWATCH_DEBUG) {
                        console.warn(
                          "[Swatch] Could not find matching size in new section"
                        );
                      }
                    }
                  }

                  setupCartDrawerForm();
                  if (theme.CartDrawer) {
                    const drawerForm =
                      document.querySelector("#CartDrawerForm");
                    if (drawerForm) {
                      window.cartDrawer = new theme.CartDrawer();
                      if (SWATCH_DEBUG) {
                        console.log("[CartDrawer] Reinitialized");
                      }
                    } else {
                      if (SWATCH_DEBUG) {
                        console.warn(
                          "[CartDrawer] Form not found, skipping drawer init"
                        );
                      }
                    }
                  }

                  // Re-initialize VariantAvailability
                  const productJsonEl = newSection.querySelector(
                    "[data-product-json]"
                  );
                  const productData = productJsonEl
                    ? JSON.parse(productJsonEl.innerHTML)
                    : null;
                  if (productData) {
                    const container =
                      newSection.querySelector(".product-block");
                    const type = container.querySelector(
                      ".variant-input-wrap select"
                    )
                      ? "dropdown"
                      : "button";
                    new theme.VariantAvailability({
                      type: type,
                      variantsObject: productData.variants,
                      currentVariantObject: productData.currentVariant,
                      container: container,
                      namespace: "",
                    });
                  } else {
                    if (SWATCH_DEBUG) {
                      console.warn(
                        "[Swatch] Could not reinitialize VariantAvailability: no product JSON found"
                      );
                    }
                  }

                  window.history.pushState({}, "", product.url);

                  // 🔁 Re-run swatch population
                  fetchRelatedProducts(baseProductName).then(
                    (relatedProducts) => {
                      populateRelatedProducts(relatedProducts, baseProductName);
                    }
                  );

                  // Klarna installment update on variant change
                  const klarnaContainer =
                    document.getElementById("klarna-installment");
                  const newPriceEl = newSection.querySelector(
                    "[data-product-json]"
                  );
                  if (klarnaContainer && newPriceEl) {
                    try {
                      const productJson = JSON.parse(newPriceEl.innerHTML);
                      const variantPrice = productJson.currentVariant?.price;
                      if (variantPrice) {
                        const formattedInstallment = Shopify.formatMoney(
                          variantPrice / 3,
                          "{{ amount_with_currency }}"
                        );
                        const amountEl = klarnaContainer.querySelector(
                          ".installment-amount"
                        );
                        if (amountEl)
                          amountEl.textContent = formattedInstallment;
                      }
                    } catch (e) {
                      if (SWATCH_DEBUG) {
                        console.warn(
                          "[Klarna] Failed to update installment price",
                          e
                        );
                      }
                    }
                  }
                }
              };

              if (!mainImg) {
                if (SWATCH_DEBUG) {
                  console.warn(
                    "[Swatch] Main image not found in new section, replacing anyway"
                  );
                }
                doReplaceSection();
                return;
              }

              const preload = new window.Image();
              preload.src = mainImg.src;
              preload.onload = () => {
                if (SWATCH_DEBUG) {
                  console.log(
                    "[Swatch] Main image preloaded. Replacing section."
                  );
                }
                doReplaceSection();
              };
            })
            .catch((err) => {
              console.error("[Swatch] Section fetch failed:", err);
              window.location.href = link.href;
            });
        }, 50);
      });

      swatchMount.appendChild(listItem);
      // Aggressive prefetch for all swatches now visible
      const prefetchLink = document.createElement("link");
      prefetchLink.rel = "prefetch";
      prefetchLink.href = product.url;
      prefetchLink.as = "document";
      prefetchLink.crossOrigin = "anonymous";
      document.head.appendChild(prefetchLink);
    });

    if (SWATCH_DEBUG) console.log("[Swatch] Finished rendering swatches");
  };

  // Try to populate from sessionStorage cache immediately
  let initialProducts = null;
  try {
    const slug = baseProductName
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-\/]/g, "");
    const cache = sessionStorage.getItem(`relatedProducts_${slug}`);
    if (cache) {
      const parsed = JSON.parse(cache);
      initialProducts = parsed.products;
    }
  } catch (e) {
    console.error("[Swatch Error] Invalid cached related products", e);
  }
  if (initialProducts) {
    populateRelatedProducts(initialProducts, baseProductName);
  }
  fetchRelatedProducts(baseProductName).then((relatedProducts) => {
    if (SWATCH_DEBUG)
      console.log("[Swatch] Render triggered for related products");
    populateRelatedProducts(relatedProducts, baseProductName);
  });

  // Klarna installment recalculation on size swatch click
  const sizeInputs = document.querySelectorAll(
    '.variant-input input[type="radio"]'
  );
  sizeInputs.forEach((input) => {
    input.addEventListener("click", () => {
      const priceText = document.querySelector("[data-product-price]");
      if (!priceText) return;

      const price = parseFloat(priceText.textContent.replace(/[^0-9.]/g, ""));
      if (isNaN(price)) return;

      const klarnaContainer = document.getElementById("klarna-installment");
      const amountEl = klarnaContainer?.querySelector(".installment-amount");
      if (klarnaContainer && amountEl) {
        const installment = formatMoney((price * 100) / 3, "£{{amount}}");
        amountEl.textContent = installment;
      }
    });
  });
});

function sortSizeSwatches() {
  const sizeWrapper = document.querySelector(
    ".variant-wrapper.variant-size.js"
  );
  if (!sizeWrapper) return;

  const fieldset = sizeWrapper.querySelector("fieldset.variant-input-wrap");
  const sizeInputs = Array.from(fieldset.querySelectorAll(".variant-input"));
  if (!sizeInputs.length) return;

  const sizeOrder = [
    "XXXS",
    "XXS",
    "XS",
    "S",
    "M",
    "L",
    "XL",
    "XXL",
    "XXXL",
    "XXXXL",
    ...Array.from({ length: 16 }, (_, i) => `UK ${i + 1}`),
    ...Array.from({ length: 21 }, (_, i) => `EU ${i + 30}`),
  ];

  sizeInputs.sort((a, b) => {
    const aVal = a.getAttribute("data-value").toUpperCase();
    const bVal = b.getAttribute("data-value").toUpperCase();
    const aIndex = sizeOrder.indexOf(aVal);
    const bIndex = sizeOrder.indexOf(bVal);
    if (aIndex === -1 && bIndex === -1) return aVal.localeCompare(bVal);
    if (aIndex === -1) return 1;
    if (bIndex === -1) return -1;
    return aIndex - bIndex;
  });

  sizeInputs.forEach((input) => fieldset.appendChild(input));
}

document.addEventListener("DOMContentLoaded", sortSizeSwatches);
document.addEventListener("shopify:section:load", sortSizeSwatches);
